export default {
  auth: {
    redirectUrl: `${window.location.origin}/callback`,
    responseType: 'token id_token',
    audience: `https://${process.env.REACT_APP_AUTH0_DOMAIN}/userinfo`,
  },
  theme: {
    primaryColor: 'green',
    foregroundColor: 'black',
    socialButtonStyle: 'small',
    logo: `${window.location.origin}/assets/Sagitario-logo-green.svg`,
    authButtons: {
      connectionName: {},
    },
  },
  allowedConnections: ['azure'],
  languageDictionary: { title: '' },
  closable: false,
  allowAutocomplete: true,
  rememberLastLogin: false,
  language: 'pt-br',
  autoclose: true,
};
